import { initialErrors } from '../Constants/Districts.constants';
import { Types } from '../Constants/Types';
import DistrictType from '../Interfaces/districts.interface';

const DistrictsReducer = (
  state: DistrictType['status'] = {
    districts: [],
    ldistricts: false,
    error: initialErrors,
  },
  action: DistrictType['action'],
) => {
  switch (action.type) {
    case Types.FETCH_DISTRICTS:
      return {
        ...state,
        districts: action.payload,
      };

    case Types.START_DISTRICTS:
      return { ...state, ldistricts: true };

    case Types.END_DISTRICTS:
      return { ...state, ldistricts: false };

    case Types.ERROR_DISTRICT:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    case Types.RESET_DISTRICT:
      return { ...state, error: initialErrors };

    default:
      return state;
  }
};

export default DistrictsReducer;

